import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { FlowBlockValueTemplateDurationSchema } from '../../blockValue/templateDuration.js';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowSubflowV2BlockConfigSchema } from '../subflow/v2/config.js';
import { FlowBlockType } from '../type.js';
/**
 * The `subFlow` here is structurally validated only; flow-api replaces it with the variant that
 * also checks the targeted flow has a published version.
 */
export const FlowRepeatBlockConfigSchema = z.object({
    /**
     * The sub-flow to execute repeatedly
     */
    subFlow: FlowSubflowV2BlockConfigSchema,
    /**
     * A script whose value says whether to stop repeating
     */
    untilConditionScript: z.string().min(1, { message: 'Condition is required.' }),
    /**
     * Maximum number of times to execute the sub-flow
     */
    maximumIterations: z.number().int().positive(),
    /**
     * (Optional) A duration to wait between each execution of the sub-flow
     */
    iterationStepDuration: FlowBlockValueTemplateDurationSchema().optional(),
});
export const FlowRepeatBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.Repeat),
    config: FlowRepeatBlockConfigSchema,
    returnType: z.literal(FlowProducedType.Any).default(FlowProducedType.Any),
});
//# sourceMappingURL=config.js.map